<template>
    <v-app>
        <v-row class="app" no-gutters>
            <sidebar v-if="isLoggedIn" />
            <router-view />
        </v-row>
    </v-app>
</template>

<script>
    import Sidebar from '@/components/Sidebar'
    export default {
        name: 'App',
        components: {
            Sidebar
        },
        data: () => ({
        }),
        computed: {
            isLoggedIn() {
                return this.$store.getters.isLoggedIn
            }
        }
    }
</script>

<style>
:root {
    --admin-navy: #213050;
    --admin-red: #bf2d3a;
    --admin-bg-soft: #f7f8fc;
}

.v-application {
    background: linear-gradient(180deg, #ffffff 0%, var(--admin-bg-soft) 100%);
}

.theme--light.v-btn.primary,
.v-application .v-btn.create-button.primary {
    background: linear-gradient(135deg, var(--admin-navy) 0%, var(--admin-red) 100%) !important;
    border: 0 !important;
    color: #fff !important;
    letter-spacing: 0.02em;
    transition: transform 0.16s ease, box-shadow 0.16s ease, filter 0.16s ease;
}

.theme--light.v-btn.primary:hover,
.v-application .v-btn.create-button.primary:hover {
    box-shadow: 0 10px 22px rgba(33, 48, 80, 0.28);
    filter: saturate(1.05);
    transform: translateY(-1px);
}

.theme--light.v-btn.secondary {
    background: linear-gradient(135deg, #9f2631 0%, var(--admin-red) 100%) !important;
    border: 0 !important;
    color: #fff !important;
    letter-spacing: 0.02em;
    transition: transform 0.16s ease, box-shadow 0.16s ease, filter 0.16s ease;
}

.theme--light.v-btn.secondary:hover {
    box-shadow: 0 10px 22px rgba(191, 45, 58, 0.28);
    filter: saturate(1.05);
    transform: translateY(-1px);
}

.theme--light.v-pagination .v-pagination__item--active {
    background: linear-gradient(135deg, var(--admin-navy) 0%, var(--admin-red) 100%) !important;
    color: #fff !important;
}

.theme--light.v-input .v-label {
    color: var(--admin-navy) !important;
}

.theme--light.v-text-field > .v-input__control > .v-input__slot:before {
    border-color: rgba(33, 48, 80, 0.45) !important;
}

.theme--light.v-text-field > .v-input__control > .v-input__slot:after {
    border-color: var(--admin-red) !important;
}

.theme--light.v-input input,
.theme--light.v-input textarea {
    caret-color: var(--admin-red) !important;
}

.v-data-table,
.v-card,
.v-form {
    border: 1px solid rgba(33, 48, 80, 0.12);
    border-radius: 10px;
}

.v-application .v-container {
    padding: 24px 28px;
}

.v-application .v-form {
    background: rgba(255, 255, 255, 0.9);
    padding: 20px 22px 14px;
    margin-top: 8px;
}

.v-application .v-form > .v-input,
.v-application .v-form > .v-text-field,
.v-application .v-form > .v-select,
.v-application .v-form > .v-autocomplete,
.v-application .v-form > .v-file-input,
.v-application .v-form > .v-menu,
.v-application .v-form > .body-editor,
.v-application .v-form > .image-input,
.v-application .v-form > .gallery-wrapper {
    margin-bottom: 14px;
}

.v-application .submit-button-wrapper {
    margin-top: 22px !important;
    padding-bottom: 10px;
}

.v-data-table {
    box-shadow: 0 10px 26px rgba(33, 48, 80, 0.08);
}

@media (max-width: 850px) {
    .v-application .v-container {
        padding: 16px;
    }

    .v-application .v-form {
        padding: 14px 14px 8px;
    }
}

.theme--light.v-data-table thead th {
    color: var(--admin-navy) !important;
    font-weight: 700;
}

</style>

<style scoped>

.app {
    flex-wrap: nowrap;
}

@media (max-width: 850px) {
.router {
    width: 70%;
}
}
</style>
